import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useCurrentForm } from 'hooks/risks'
// types
import { IRiskFieldValue } from 'types/risk'
// components
import InlineFunction from './components/InlineFunction'
// context
import { RiskTransactionsContext } from 'containers/Risks/Risk/Edit/layers/RiskTransactions'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// utils
import { last, orderBy } from 'lodash'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: min-content;
  gap: 4px;
  padding: 4px 0;
`

interface Props {
  value: IRiskFieldValue
}

const InlineFunctions: React.FC<Props> = ({ value }) => {
  const { field, fieldLink } = useCurrentForm()

  const { inlineFunctions } = React.useContext(RiskTransactionsContext)
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const functionsToShow = orderBy(
    inlineFunctions?.filter(
      (item) => item.fieldValueId === value?.fieldValueId || item.fieldValueId === value?.parentFieldValueId
    ) || [],
    'position'
  )

  const fields = riskTemplate.fields.filter(
    ({ entityId, parentFieldId }) => entityId === field.entityId && parentFieldId === field.parentFieldId
  )

  const isNoSecondaryFields = fields.length === 1
  const isLastSecondaryField = !fieldLink.primary && last(orderBy(fields, 'position'))?.id === field.id

  const showFunctions = isNoSecondaryFields || isLastSecondaryField

  if (!functionsToShow.length || !showFunctions) {
    return null
  }

  return (
    <Wrapper>
      {functionsToShow.map((item) => (
        <InlineFunction key={item.id} data={item} field={field} />
      ))}
    </Wrapper>
  )
}

export default InlineFunctions
